(function () {
  "use strict";

  var comparisonSelector = "[data-mfy-ai-phone-comparison]";
  var sourceSelector = "[data-mfy-tee-preview-source]";
  var defaultMockupLayouts = {
    "1": [[28.947, 8.612], [71.770, 8.612], [71.691, 69.537], [29.107, 69.458]],
    "2": [[17.305, 9.490], [64.912, 10.367], [67.943, 80.383], [18.740, 83.094]],
    "3": [[26.794, 10.925], [71.132, 15.391], [75.120, 82.137], [28.788, 84.131]],
    "4": [[24.163, 16.667], [68.820, 15.072], [75.997, 79.187], [30.064, 83.892]]
  };
  var dogMockupLayouts = {
    "1": [[29.745, 8.692], [69.697, 8.692], [69.697, 64.274], [29.745, 64.274]],
    "2": [[33.732, 8.118], [70.574, 6.116], [70.574, 63.477], [33.732, 62.679]],
    "3": [[30.462, 6.619], [69.298, 6.619], [69.298, 61.164], [30.462, 61.164]]
  };
  var mockupLayouts = /\/products\/hundeportrait-aquarell-personalisiert\/?$/.test(window.location.pathname)
    ? dogMockupLayouts
    : defaultMockupLayouts;

  var currentObjectUrl = "";
  var lastRenderedSignature = "";
  var lastRenderedMediaUrl = "";
  var uploadBaselineUrl = "";
  var pendingArtworkUrl = "";
  var artworkLoadToken = 0;
  var lastSyncedArtworkSignature = "";
  var hasCustomerPhoto = false;
  var waitingForAi = false;
  var renderTimer = 0;
  var retryTimer = 0;
  var svgIdCounter = 0;
  var uploadStartedAt = 0;
  var mockupResizeObserver = null;
  var personalizationText = "";
  var personalizationColor = "#000000";
  var nameSyncFrame = 0;
  var namePollTimer = 0;
  var observedArtworkSvg = null;
  var artworkSourceObserver = null;
  var artworkContainerObserver = null;
  var teeinblueBootstrapObserver = null;

  function comparison() {
    return document.querySelector(comparisonSelector);
  }

  function previewSource() {
    return document.querySelector(sourceSelector);
  }

  function teeinblueRoot() {
    return document.getElementById("teeinblue-wrapper") || document.getElementById("teeinblue-form");
  }

  function sourceArtworkSvg() {
    return document.querySelector(
      "#teeinblue-wrapper .tee-artworks-wrapper svg.tee-mockup-artwork[id^='tee-artwork-']"
    );
  }

  function sourceArtworkImageUrl() {
    var artwork = sourceArtworkSvg();
    if (!artwork) return "";
    var image = artwork.querySelector(
      ".tee-layer-photo image[href], .tee-layer-photo image[xlink\\:href], image[href], image[xlink\\:href]"
    );
    if (!image) return "";
    return absoluteUrl(
      image.getAttribute("href") ||
      image.getAttribute("xlink:href") ||
      image.getAttributeNS("http://www.w3.org/1999/xlink", "href")
    );
  }

  function isTeeinbluePhotoInput(input) {
    if (!input || !input.matches('input[type="file"]')) return false;
    var accept = (input.getAttribute("accept") || "").toLowerCase();
    var id = (input.id || "").toLowerCase();
    var name = (input.name || "").toLowerCase();
    var insidePersonalizer = Boolean(input.closest(
      "#teeinblue-wrapper, [id*='teeinblue'], [class*='tee-photo'], [data-tee-photo], .uploadly-app-slot"
    ));

    return insidePersonalizer && Boolean(
      accept.indexOf("image") !== -1 ||
      id.indexOf("photo") !== -1 ||
      id.indexOf("image") !== -1 ||
      name.indexOf("photo") !== -1 ||
      name.indexOf("image") !== -1 ||
      input.closest("[class*='tee-photo'], [data-tee-photo]")
    );
  }

  function status(text, generating) {
    var root = comparison();
    if (!root) return;
    var textNode = root.querySelector("[data-mfy-preview-status-text]");
    if (textNode && text) textNode.textContent = text;
    root.classList.toggle("is-generating", Boolean(generating));
  }

  function updatePhoneFit(image) {
    var root = comparison();
    if (!root || !image || !image.naturalWidth || !image.naturalHeight) return;

    var mode = root.dataset.phoneFit || "smart";
    var screen = root.querySelector("[data-mfy-phone-screen]");
    if (!screen) return;

    var screenRatio = screen.clientWidth && screen.clientHeight
      ? screen.clientWidth / screen.clientHeight
      : 0.46;
    var photoRatio = image.naturalWidth / image.naturalHeight;
    var closeToScreen = Math.abs(photoRatio - screenRatio) / screenRatio < 0.14;

    root.classList.toggle("is-phone-cover", mode === "cover" || (mode === "smart" && closeToScreen));
  }

  function showOriginal(file) {
    if (!file || !/^image\//i.test(file.type || "")) return;

    if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
    currentObjectUrl = URL.createObjectURL(file);

    var root = comparison();
    if (!root) return;

    root.querySelectorAll("[data-mfy-original-photo-bg]").forEach(function (image) {
      image.src = currentObjectUrl;
    });
    root.querySelectorAll("[data-mfy-original-photo]").forEach(function (image) {
      image.addEventListener("load", function onLoad() {
        image.removeEventListener("load", onLoad);
        updatePhoneFit(image);
      });
      image.src = currentObjectUrl;
    });

    root.classList.add("has-original-photo");
    hasCustomerPhoto = true;
    waitingForAi = true;
    uploadStartedAt = Date.now();
    status("KI-Kunstwerk wird erstellt", true);
    preloadMockupImages();
    syncPersonalizationToMockups();
  }

  function clearOriginal() {
    if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
    currentObjectUrl = "";
    hasCustomerPhoto = false;
    waitingForAi = false;
    uploadStartedAt = 0;

    var root = comparison();
    if (!root) return;
    root.querySelectorAll("[data-mfy-original-photo], [data-mfy-original-photo-bg]").forEach(function (image) {
      image.removeAttribute("src");
    });
    root.classList.remove("has-original-photo", "is-phone-cover");
  }

  function clearArtwork() {
    var root = comparison();
    if (!root) return;
    var target = root.querySelector("[data-mfy-ai-poster-preview]");
    if (target) target.replaceChildren();
    root.classList.remove("has-ai-preview");
    lastRenderedSignature = "";
    lastRenderedMediaUrl = "";
    pendingArtworkUrl = "";
    artworkLoadToken += 1;
    restoreVisibleMockup();
  }

  function absoluteUrl(value) {
    if (!value) return "";
    var trimmed = String(value).trim();
    if (!trimmed || trimmed.charAt(0) === "#" || trimmed.indexOf("url(#") === 0) return "";
    try {
      return new URL(trimmed, document.baseURI).href;
    } catch (error) {
      return trimmed;
    }
  }

  function cssUrl(value) {
    if (!value) return "";
    var match = String(value).match(/url\((['"]?)(.*?)\1\)/i);
    return match && match[2] ? absoluteUrl(match[2]) : "";
  }

  function nodeImageUrls(node) {
    if (!node || !node.querySelectorAll) return [];
    var urls = [];

    function add(value) {
      var normalized = absoluteUrl(value);
      if (!normalized || urls.indexOf(normalized) !== -1) return;
      urls.push(normalized);
    }

    if (node.matches && node.matches("img")) add(node.currentSrc || node.src || node.getAttribute("src"));
    if (node.matches && node.matches("image, feImage")) {
      add(node.getAttribute("href") || node.getAttribute("xlink:href") ||
        node.getAttributeNS("http://www.w3.org/1999/xlink", "href"));
    }

    node.querySelectorAll("img").forEach(function (image) {
      add(image.currentSrc || image.src || image.getAttribute("src") || image.dataset.src);
    });

    node.querySelectorAll("image, feImage").forEach(function (image) {
      add(image.getAttribute("href") || image.getAttribute("xlink:href") ||
        image.getAttributeNS("http://www.w3.org/1999/xlink", "href"));
    });

    [node].concat(Array.prototype.slice.call(node.querySelectorAll("[style]"))).forEach(function (element) {
      var fromStyle = cssUrl(element.getAttribute && element.getAttribute("style"));
      if (fromStyle) add(fromStyle);
      try {
        var fromComputed = cssUrl(window.getComputedStyle(element).backgroundImage);
        if (fromComputed) add(fromComputed);
      } catch (error) {}
    });

    return urls;
  }

  function stringHash(value) {
    var hash = 2166136261;
    var text = String(value || "");
    for (var index = 0; index < text.length; index += 1) {
      hash ^= text.charCodeAt(index);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return (hash >>> 0).toString(36);
  }

  function personalizationStorageKey() {
    return "mfy-ai-personalization-v1:" + window.location.pathname.replace(/\/$/, "");
  }

  function personalizationColorStorageKey() {
    return "mfy-ai-personalization-color-v1:" + window.location.pathname.replace(/\/$/, "");
  }

  function normalizePersonalizationText(value) {
    return String(value || "").replace(/\s+/g, " ").trim().slice(0, 30);
  }

  function storedPersonalizationText() {
    try {
      return normalizePersonalizationText(window.sessionStorage.getItem(personalizationStorageKey()) || "");
    } catch (error) {
      return "";
    }
  }

  function persistPersonalizationText(value) {
    try {
      if (value) {
        window.sessionStorage.setItem(personalizationStorageKey(), value);
      } else {
        window.sessionStorage.removeItem(personalizationStorageKey());
      }
    } catch (error) {}
  }

  function normalizePersonalizationColor(value) {
    var color = String(value || "").trim();
    if (/^#[0-9a-f]{6}$/i.test(color)) return color.toUpperCase();
    if (/^[0-9a-f]{6}$/i.test(color)) return ("#" + color).toUpperCase();
    return "";
  }

  function storedPersonalizationColor() {
    try {
      return normalizePersonalizationColor(
        window.sessionStorage.getItem(personalizationColorStorageKey()) || ""
      );
    } catch (error) {
      return "";
    }
  }

  function persistPersonalizationColor(value) {
    try {
      window.sessionStorage.setItem(personalizationColorStorageKey(), value);
    } catch (error) {}
  }

  function isPosterColorInput(input) {
    if (!input || !input.matches("input[type='radio']")) return false;
    var field = input.closest(".tee-field--color");
    if (!field) return false;
    var heading = field.querySelector(".tee-field__heading");
    var label = ((heading && heading.textContent) || field.textContent || "").toLowerCase();
    return /textfarbe|text color|font color/.test(label);
  }

  function selectedPersonalizationColor() {
    var inputs = document.querySelectorAll(".tee-field--color input[type='radio']:checked");
    for (var index = 0; index < inputs.length; index += 1) {
      if (!isPosterColorInput(inputs[index])) continue;
      var color = normalizePersonalizationColor(inputs[index].value);
      if (color) return color;
    }
    return "";
  }

  function syncColorCartProperty(value) {
    var form = document.getElementById("product-upload-form");
    if (!form) return;
    var input = form.querySelector("input[name='properties[_MFY_TEXT_COLOR]']");
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_MFY_TEXT_COLOR]";
      form.appendChild(input);
    }
    input.value = value;
    input.setAttribute("value", value);
  }

  function nameInputDescriptor(input) {
    var parts = [
      input.getAttribute("placeholder"),
      input.getAttribute("aria-label"),
      input.getAttribute("name"),
      input.id
    ].filter(Boolean);

    if (input.labels) {
      Array.prototype.forEach.call(input.labels, function (label) {
        parts.push(label.textContent || "");
      });
    }

    var group = input.closest(".tee-field, [data-tee-field], label, [class*='option'], [class*='personalization']");
    if (group) parts.push(group.textContent || "");
    return parts.join(" ").toLowerCase();
  }

  function isPosterNameInput(input) {
    if (!input || !input.matches("input[type='text'], input:not([type]), textarea")) return false;
    var descriptor = nameInputDescriptor(input);
    return /anna\s*&\s*max|namen?\s+auf\s+dem\s+poster|name\s+(?:des|vom)\s+hund|hundename|wunschnam|eure\s+namen/.test(descriptor);
  }

  function posterNameInput() {
    /* The form and the preview do not always share the same Teeinblue wrapper.
       Search the whole document so the optional name field is never missed. */
    var fields = document.querySelectorAll("input[type='text'], input:not([type]), textarea");
    for (var index = 0; index < fields.length; index += 1) {
      if (isPosterNameInput(fields[index])) return fields[index];
    }
    return null;
  }

  function createPersonalizationLayer(value) {
    if (!value) return null;
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    var text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    var length = Array.from(value).length;
    var fontSize = Math.max(48, 78 - Math.max(0, length - 16) * 2);

    svg.classList.add("mfy-ai-personalized-text");
    svg.setAttribute("viewBox", "0 0 1000 1000");
    svg.setAttribute("preserveAspectRatio", "none");
    svg.setAttribute("aria-hidden", "true");
    svg.style.position = "absolute";
    svg.style.inset = "0";
    svg.style.zIndex = "20";
    svg.style.display = "block";
    svg.style.width = "100%";
    svg.style.height = "100%";
    svg.style.maxWidth = "none";
    svg.style.maxHeight = "none";
    svg.style.overflow = "visible";
    svg.style.background = "transparent";
    svg.style.pointerEvents = "none";
    text.setAttribute("x", "500");
    text.setAttribute("y", "927");
    text.setAttribute("text-anchor", "middle");
    text.setAttribute("font-family", "Blackrush, Segoe Script, Brush Script MT, cursive");
    text.setAttribute("font-size", String(fontSize));
    text.setAttribute("font-weight", "400");
    text.setAttribute("fill", personalizationColor);
    text.setAttribute("stroke", personalizationColor === "#FFFFFF" ? "rgba(0,0,0,.35)" : "rgba(255,255,255,.45)");
    text.setAttribute("stroke-width", "1.4");
    text.setAttribute("paint-order", "stroke fill");
    text.textContent = value;
    svg.appendChild(text);
    return svg;
  }

  function renderPersonalizationLayer() {
    var root = comparison();
    var target = root && root.querySelector("[data-mfy-ai-poster-preview]");
    if (!target) return;
    Array.prototype.slice.call(target.children).forEach(function (child) {
      if (child.classList && child.classList.contains("mfy-ai-personalized-text")) child.remove();
    });
    var layer = createPersonalizationLayer(personalizationText);
    if (layer && target.firstElementChild) target.appendChild(layer);
  }

  function directComposite(overlay) {
    if (!overlay) return null;
    var composite = Array.prototype.find.call(overlay.children, function (child) {
      return child.classList && child.classList.contains("mfy-ai-composite");
    });
    if (composite) return composite;

    composite = document.createElement("div");
    composite.className = "mfy-ai-composite";
    composite.setAttribute("aria-hidden", "true");
    overlay.appendChild(composite);
    return composite;
  }

  function replaceCompositeNameLayer(composite) {
    if (!composite) return false;
    Array.prototype.slice.call(composite.children).forEach(function (child) {
      if (child.classList && child.classList.contains("mfy-ai-personalized-text")) child.remove();
    });

    var layer = createPersonalizationLayer(personalizationText);
    if (layer) composite.appendChild(layer);
    return Boolean(layer);
  }

  function syncPersonalizationToMockups() {
    if (!hasCustomerPhoto) return false;
    var gallery = document.querySelector("[data-mfy-product-gallery]");
    var hasVisibleOverlay = false;

    mockupContainers().forEach(function (item) {
      var overlay = ensureMockupOverlay(item.container, item.index);
      if (!overlay) return;
      var composite = directComposite(overlay);
      replaceCompositeNameLayer(composite);

      if (composite && !composite.children.length) composite.remove();
      if (overlay.firstElementChild) {
        applyMockupGeometry(item.container, overlay, item.index);
        hasVisibleOverlay = true;
      }
    });

    if (gallery) gallery.classList.toggle("has-mfy-ai-mockups", hasVisibleOverlay);
    return hasVisibleOverlay;
  }

  function setPersonalizationText(value, shouldPersist) {
    var nextValue = normalizePersonalizationText(value);
    if (shouldPersist) persistPersonalizationText(nextValue);
    if (nextValue === personalizationText) return;
    personalizationText = nextValue;
    renderPersonalizationLayer();
    lastSyncedArtworkSignature = "";
    if (!syncVisibleMockup()) syncPersonalizationToMockups();
  }

  function setPersonalizationColor(value, shouldPersist) {
    var nextColor = normalizePersonalizationColor(value);
    if (!nextColor) return;
    if (shouldPersist) persistPersonalizationColor(nextColor);
    syncColorCartProperty(nextColor);
    if (nextColor === personalizationColor) return;
    personalizationColor = nextColor;
    renderPersonalizationLayer();
    lastSyncedArtworkSignature = "";
    if (!syncVisibleMockup()) syncPersonalizationToMockups();
  }

  function restorePersonalizationInput() {
    var input = posterNameInput();
    if (!input) return;
    if (input.value) {
      setPersonalizationText(input.value, true);
      return;
    }
    if (!personalizationText || input.dataset.mfyNameRestored === "true") return;
    var prototype = input.matches("textarea") ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(prototype, "value");
    input.dataset.mfyNameRestored = "true";
    if (descriptor && descriptor.set) {
      descriptor.set.call(input, personalizationText);
    } else {
      input.value = personalizationText;
    }
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function scheduleNameSync() {
    if (nameSyncFrame) return;
    nameSyncFrame = window.requestAnimationFrame(function () {
      nameSyncFrame = 0;
      restorePersonalizationInput();
    });
  }

  function pollPersonalizationInput() {
    var color = selectedPersonalizationColor();
    if (color) setPersonalizationColor(color, true);
    var input = posterNameInput();
    if (!input) return;
    var value = normalizePersonalizationText(input.value);
    if (value !== personalizationText) setPersonalizationText(value, true);
  }

  function nodeSignature(node, extra) {
    if (!node) return "";
    var parts = [];
    nodeImageUrls(node).forEach(function (url) { parts.push(url); });

    if (node.querySelectorAll) {
      node.querySelectorAll("[href], [xlink\\:href], [src], [data-src], [data-url], [data-image], [data-preview], [style]")
        .forEach(function (element) {
          ["href", "xlink:href", "src", "data-src", "data-url", "data-image", "data-preview", "style"].forEach(function (name) {
            var value = element.getAttribute(name);
            if (value) parts.push(name + "=" + value);
          });
        });
    }

    if (!parts.length && node.outerHTML) parts.push(node.outerHTML);
    if (!parts.length) return "";
    return (extra || "node") + ":" + stringHash(parts.join("|"));
  }

  function restoreVisibleMockup() {
    var gallery = document.querySelector("[data-mfy-product-gallery]");
    if (!gallery) return;

    gallery.classList.remove("has-mfy-ai-mockups");
    gallery.querySelectorAll("[data-mfy-ai-mockup-overlay]").forEach(function (overlay) {
      overlay.replaceChildren();
    });
    lastSyncedArtworkSignature = "";
  }

  function mockupContainers() {
    var gallery = document.querySelector("[data-mfy-product-gallery]");
    if (!gallery) return [];
    var containers = [];

    Object.keys(mockupLayouts).forEach(function (index) {
      [
        gallery.querySelector(".gallery__slide[data-index='" + index + "']"),
        gallery.querySelector(".gthumb[data-index='" + index + "']")
      ].filter(Boolean).forEach(function (container) {
        containers.push({ container: container, index: index });
      });
    });

    return containers;
  }

  function mockupClipPath(layout) {
    return "polygon(" + layout.map(function (point) {
      return point[0] + "% " + point[1] + "%";
    }).join(", ") + ")";
  }

  function mockupMatrix(width, height, layout) {
    if (!width || !height || !layout) return "";

    var points = layout.map(function (point) {
      return { x: point[0] * width / 100, y: point[1] * height / 100 };
    });
    var p0 = points[0];
    var p1 = points[1];
    var p2 = points[2];
    var p3 = points[3];
    var dx1 = p1.x - p2.x;
    var dy1 = p1.y - p2.y;
    var dx2 = p3.x - p2.x;
    var dy2 = p3.y - p2.y;
    var sx = p0.x - p1.x + p2.x - p3.x;
    var sy = p0.y - p1.y + p2.y - p3.y;
    var denominator = dx1 * dy2 - dx2 * dy1;
    var g = 0;
    var h = 0;

    if (Math.abs(denominator) > 0.000001) {
      g = (sx * dy2 - dx2 * sy) / denominator;
      h = (dx1 * sy - sx * dy1) / denominator;
    }

    var a = p1.x - p0.x + g * p1.x;
    var b = p3.x - p0.x + h * p3.x;
    var d = p1.y - p0.y + g * p1.y;
    var e = p3.y - p0.y + h * p3.y;
    var values = [
      a / width, d / width, 0, g / width,
      b / height, e / height, 0, h / height,
      0, 0, 1, 0,
      p0.x, p0.y, 0, 1
    ];

    return "matrix3d(" + values.map(function (value) {
      return Math.abs(value) < 0.0000001 ? 0 : Number(value.toFixed(10));
    }).join(",") + ")";
  }

  function applyMockupGeometry(container, overlay, index) {
    var layout = mockupLayouts[index];
    if (!container || !overlay || !layout) return;

    var width = container.clientWidth;
    var height = container.clientHeight;
    if (!width || !height) return;

    var clipPath = mockupClipPath(layout);
    overlay.style.clipPath = clipPath;
    overlay.style.webkitClipPath = clipPath;

    var artwork = overlay.firstElementChild;
    if (!artwork) return;
    artwork.style.transform = mockupMatrix(width, height, layout);
    artwork.style.transformOrigin = "0 0";
  }

  function ensureMockupOverlay(container, index) {
    if (!container) return null;
    var overlay = container.querySelector("[data-mfy-ai-mockup-overlay='" + index + "']");
    if (overlay) return overlay;

    overlay = document.createElement("div");
    overlay.className = "mfy-ai-mockup-overlay";
    overlay.setAttribute("data-mfy-ai-mockup-overlay", index);
    overlay.setAttribute("aria-hidden", "true");
    container.appendChild(overlay);
    applyMockupGeometry(container, overlay, index);
    if (mockupResizeObserver) mockupResizeObserver.observe(container);
    return overlay;
  }

  function preloadMockupImages() {
    mockupContainers().forEach(function (item) {
      if (!item.container.matches(".gallery__slide")) return;
      var image = item.container.querySelector(":scope > img");
      if (!image) return;
      image.loading = "eager";
      var src = image.currentSrc || image.src || image.getAttribute("src");
      if (!src || image.complete) return;
      var preload = new Image();
      preload.decoding = "async";
      preload.src = src;
    });
  }

  function livePosterArtwork() {
    var root = comparison();
    return root && root.querySelector("[data-mfy-ai-poster-preview]");
  }

  function livePosterArtworkSignature(source) {
    if (!source) return "";
    var child = Array.prototype.find.call(source.children, function (element) {
      return !element.classList.contains("mfy-ai-personalized-text");
    });
    if (!child) return "";
    var signature = "";
    if (child.matches && child.matches("img")) {
      var src = absoluteUrl(child.currentSrc || child.src || child.getAttribute("src"));
      if (src) signature = "poster-img:" + stringHash(src);
    }
    if (!signature) signature = nodeSignature(child, "poster-live");
    return signature + ":name:" + stringHash(personalizationText) + ":color:" + personalizationColor;
  }

  function cloneLivePosterArtwork(source) {
    source = source || livePosterArtwork();
    if (!source || !source.firstElementChild) return null;

    var composite = document.createElement("div");
    composite.className = "mfy-ai-composite";
    composite.setAttribute("aria-hidden", "true");
    Array.prototype.forEach.call(source.children, function (child) {
      var clone = child.cloneNode(true);
      if (clone.matches && clone.matches("svg")) prefixSvgIds(clone);
      if (clone.removeAttribute) clone.removeAttribute("id");
      composite.appendChild(clone);
    });
    replaceCompositeNameLayer(composite);
    return composite;
  }

  /*
    Mirror the final artwork from image 1 into every room mockup only when that
    artwork actually changes. This avoids replacing the same overlays on every
    DOM mutation, which previously caused visible flicker.
  */
  function syncVisibleMockup() {
    if (!hasCustomerPhoto) return false;

    var sourceArtwork = livePosterArtwork();
    var signature = livePosterArtworkSignature(sourceArtwork);
    var items = mockupContainers();
    if (!sourceArtwork || !signature || !items.length) return false;

    var alreadySynced = signature === lastSyncedArtworkSignature && items.every(function (item) {
      var overlay = item.container.querySelector("[data-mfy-ai-mockup-overlay='" + item.index + "']");
      return Boolean(overlay && overlay.firstElementChild);
    });

    var gallery = document.querySelector("[data-mfy-product-gallery]");
    if (alreadySynced) {
      if (gallery) gallery.classList.add("has-mfy-ai-mockups");
      return true;
    }

    var synced = false;
    items.forEach(function (item) {
      var overlay = ensureMockupOverlay(item.container, item.index);
      if (!overlay) return;
      var composite = directComposite(overlay);
      var sourceImage = sourceArtwork.querySelector(":scope > img");
      var existingImage = composite && composite.querySelector(":scope > img");

      if (sourceImage && existingImage) {
        var nextSource = sourceImage.currentSrc || sourceImage.src || sourceImage.getAttribute("src") || "";
        if (existingImage.getAttribute("src") !== nextSource) existingImage.setAttribute("src", nextSource);
        replaceCompositeNameLayer(composite);
      } else {
        var artwork = cloneLivePosterArtwork(sourceArtwork);
        if (!artwork) return;
        overlay.replaceChildren(artwork);
      }
      applyMockupGeometry(item.container, overlay, item.index);
      synced = true;
    });

    if (synced) {
      if (gallery) gallery.classList.add("has-mfy-ai-mockups");
      lastSyncedArtworkSignature = signature;
    }
    syncPersonalizationToMockups();
    return synced;
  }

  function sourceIsBusy() {
    var scopes = [previewSource(), teeinblueRoot()].filter(Boolean);
    if (!scopes.length) return false;
    return scopes.some(function (scope) {
      return Boolean(scope.querySelector(
        "[aria-busy='true'], .tee-loading, .tee-spinner, [class*='tee-loading'], [class*='tee-spinner'], [class*='loading'][class*='tee']"
      ));
    });
  }

  function prefixSvgIds(svg) {
    svgIdCounter += 1;
    var prefix = "mfy-ai-" + svgIdCounter + "-";
    var map = {};

    svg.querySelectorAll("[id]").forEach(function (node) {
      var oldId = node.id;
      var newId = prefix + oldId;
      map[oldId] = newId;
      node.id = newId;
    });

    var attributes = ["href", "xlink:href", "fill", "stroke", "filter", "mask", "clip-path", "style"];
    svg.querySelectorAll("*").forEach(function (node) {
      attributes.forEach(function (name) {
        var value = node.getAttribute(name);
        if (!value) return;
        Object.keys(map).forEach(function (oldId) {
          value = value
            .split("url(#" + oldId + ")").join("url(#" + map[oldId] + ")")
            .split("#" + oldId).join("#" + map[oldId]);
        });
        node.setAttribute(name, value);
      });
    });

    svg.querySelectorAll("style").forEach(function (styleNode) {
      var text = styleNode.textContent || "";
      Object.keys(map).forEach(function (oldId) {
        text = text
          .split("url(#" + oldId + ")").join("url(#" + map[oldId] + ")")
          .split("#" + oldId).join("#" + map[oldId]);
      });
      styleNode.textContent = text;
    });
  }

  function cloneSvgArtwork(node) {
    var sourceSvg = node.matches && node.matches("svg") ? node : node.ownerSVGElement;
    if (!sourceSvg) return null;

    var clone;
    if (node !== sourceSvg && node.matches && node.matches("g, symbol")) {
      clone = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var viewBox = sourceSvg.getAttribute("viewBox");
      if (viewBox) clone.setAttribute("viewBox", viewBox);
      clone.appendChild(node.cloneNode(true));
    } else {
      clone = sourceSvg.cloneNode(true);
    }

    prefixSvgIds(clone);
    clone.removeAttribute("class");
    clone.removeAttribute("style");
    clone.setAttribute("width", "100%");
    clone.setAttribute("height", "100%");
    clone.setAttribute("preserveAspectRatio", "none");
    clone.setAttribute("aria-hidden", "true");
    return clone;
  }

  function imageFromUrl(url) {
    if (!url) return null;
    var image = document.createElement("img");
    image.src = url;
    image.alt = "";
    image.decoding = "async";
    image.setAttribute("aria-hidden", "true");
    return image;
  }

  function artworkStorageKey() {
    return "mfy-ai-artwork-v1:" + window.location.pathname.replace(/\/$/, "");
  }

  function persistableArtworkUrl(value) {
    var url = absoluteUrl(value);
    if (!url) return "";
    if (/^https?:/i.test(url)) return url;
    if (/^data:image\//i.test(url) && url.length <= 3000000) return url;
    return "";
  }

  function storedArtworkUrl() {
    try {
      var value = window.sessionStorage.getItem(artworkStorageKey()) || "";
      return persistableArtworkUrl(value);
    } catch (error) {
      return "";
    }
  }

  function persistArtworkUrl(value) {
    var url = persistableArtworkUrl(value);
    if (!url) return false;
    try {
      window.sessionStorage.setItem(artworkStorageKey(), url);
      syncCartPreviewProperty(url);
      return true;
    } catch (error) {
      syncCartPreviewProperty(url);
      return false;
    }
  }

  function clearPersistedArtwork() {
    try {
      window.sessionStorage.removeItem(artworkStorageKey());
    } catch (error) {}
    document.querySelectorAll("#mfy-ai-preview-property, input[name='properties[_MFY_AI_PREVIEW]']").forEach(function (input) {
      input.value = "";
      input.setAttribute("value", "");
    });
  }

  function cartPreviewUrl(value) {
    var url = absoluteUrl(value);
    return /^https?:/i.test(url) ? url : "";
  }

  function syncCartPreviewProperty(value) {
    var url = cartPreviewUrl(value);
    var inputs = Array.prototype.slice.call(document.querySelectorAll(
      "#mfy-ai-preview-property, input[name='properties[_MFY_AI_PREVIEW]']"
    ));
    var form = document.getElementById("product-upload-form");

    if (!inputs.length && form) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_MFY_AI_PREVIEW]";
      input.id = "mfy-ai-preview-property";
      form.appendChild(input);
      inputs.push(input);
    }

    inputs.forEach(function (input) {
      input.value = url;
      input.setAttribute("value", url);
    });
  }

  function persistArtworkCandidate(candidate, rendered) {
    var urls = [];
    if (candidate && candidate.urls) urls = candidate.urls.slice().reverse();
    if (candidate && candidate.url) urls.unshift(candidate.url);
    if (rendered && rendered.matches && rendered.matches("img")) {
      urls.unshift(rendered.currentSrc || rendered.src || rendered.getAttribute("src"));
    }

    for (var index = 0; index < urls.length; index += 1) {
      if (persistArtworkUrl(urls[index])) return true;
    }
    return false;
  }

  function restorePersistedArtwork() {
    var url = storedArtworkUrl();
    var root = comparison();
    var target = root && root.querySelector("[data-mfy-ai-poster-preview]");
    if (!url || !root || !target) return false;

    var image = imageFromUrl(url);
    image.addEventListener("error", function () {
      if (image.parentNode === target) target.replaceChildren();
      root.classList.remove("has-ai-preview");
      restoreVisibleMockup();
      waitingForAi = true;
      scheduleArtworkRender();
    }, { once: true });

    target.replaceChildren(image);
    renderPersonalizationLayer();
    syncCartPreviewProperty(url);
    hasCustomerPhoto = true;
    waitingForAi = false;
    uploadStartedAt = 0;
    lastRenderedSignature = "persisted:" + stringHash(url);
    lastRenderedMediaUrl = absoluteUrl(url);
    uploadBaselineUrl = sourceArtworkImageUrl();
    root.classList.add("has-ai-preview");
    status("Hohe Nachfrage – begrenzte Verfügbarkeit", false);
    syncVisibleMockup();
    return true;
  }

  function scheduleRetry() {
    window.clearTimeout(retryTimer);
    if (!hasCustomerPhoto || !waitingForAi) return;
    retryTimer = window.setTimeout(scheduleArtworkRender, 500);
  }

  function commitArtworkUrl(url) {
    if (!url || url === lastRenderedMediaUrl || url === pendingArtworkUrl) return;
    pendingArtworkUrl = url;
    artworkLoadToken += 1;
    var token = artworkLoadToken;
    var image = document.createElement("img");
    var committed = false;

    image.alt = "";
    image.decoding = "async";
    image.setAttribute("aria-hidden", "true");

    function commit() {
      if (committed || token !== artworkLoadToken || pendingArtworkUrl !== url) return;
      if (!image.naturalWidth) return;
      committed = true;

      var root = comparison();
      var target = root && root.querySelector("[data-mfy-ai-poster-preview]");
      if (!root || !target) return;

      target.replaceChildren(image);
      renderPersonalizationLayer();
      lastRenderedSignature = "artwork-url:" + stringHash(url);
      lastRenderedMediaUrl = url;
      pendingArtworkUrl = "";
      uploadBaselineUrl = "";
      persistArtworkUrl(url);
      waitingForAi = false;
      root.classList.add("has-ai-preview");
      status("Hohe Nachfrage – begrenzte Verfügbarkeit", false);
      syncVisibleMockup();
    }

    image.addEventListener("load", commit, { once: true });
    image.addEventListener("error", function () {
      if (token === artworkLoadToken) pendingArtworkUrl = "";
    }, { once: true });
    image.src = url;
    if (image.decode) {
      image.decode().then(commit).catch(function () {
        if (image.complete && image.naturalWidth) commit();
      });
    }
  }

  function renderArtwork() {
    renderTimer = 0;
    if (!hasCustomerPhoto) return;

    /* During the first seconds Teeinblue can briefly keep its loading class
       while already updating the artwork URL. After 7 seconds, do not let a
       stale loading indicator block the customer's result forever. */
    if (sourceIsBusy() && (!uploadStartedAt || Date.now() - uploadStartedAt < 7000)) {
      scheduleRetry();
      return;
    }

    var url = sourceArtworkImageUrl();
    if (!url || url === uploadBaselineUrl || url === lastRenderedMediaUrl) {
      scheduleRetry();
      return;
    }
    commitArtworkUrl(url);
  }

  function scheduleArtworkRender() {
    if (renderTimer) return;
    renderTimer = window.requestAnimationFrame(renderArtwork);
  }

  function captureBaseline() {
    uploadBaselineUrl = sourceArtworkImageUrl();
    pendingArtworkUrl = "";
    artworkLoadToken += 1;
  }

  document.addEventListener("change", function (event) {
    var input = event.target;
    if (isPosterColorInput(input)) {
      setPersonalizationColor(input.value, true);
      return;
    }
    if (isPosterNameInput(input)) {
      setPersonalizationText(input.value, true);
      return;
    }
    if (!isTeeinbluePhotoInput(input)) return;

    if (input.files && input.files[0]) {
      captureBaseline();
      showOriginal(input.files[0]);
      scheduleArtworkRender();
    }
  }, true);

  document.addEventListener("input", function (event) {
    if (isPosterColorInput(event.target)) {
      setPersonalizationColor(event.target.value, true);
      return;
    }
    if (!isPosterNameInput(event.target)) return;
    setPersonalizationText(event.target.value, true);
  }, true);

  document.addEventListener("click", function (event) {
    var removeButton = event.target.closest(
      ".tee-photo-remove, .tee-photo__remove, [data-action='remove-photo'], [data-action='remove-image'], [class*='photo-remove'], [class*='image-remove']"
    );
    if (removeButton) {
      clearPersistedArtwork();
      window.setTimeout(function () {
        clearOriginal();
        clearArtwork();
        uploadBaselineUrl = "";
        status("Live-Vorschau", false);
      }, 120);
      return;
    }

  }, true);

  function observeArtworkSource() {
    var artwork = sourceArtworkSvg();
    var container = document.getElementById("teeinblue-wrapper");

    if (!artwork && observedArtworkSvg) {
      if (artworkSourceObserver) artworkSourceObserver.disconnect();
      artworkSourceObserver = null;
      observedArtworkSvg = null;
    }

    if (artwork && artwork !== observedArtworkSvg) {
      if (artworkSourceObserver) artworkSourceObserver.disconnect();
      observedArtworkSvg = artwork;
      artworkSourceObserver = new MutationObserver(function () {
        if (hasCustomerPhoto) scheduleArtworkRender();
      });
      artworkSourceObserver.observe(artwork, {
        attributes: true,
        attributeFilter: ["href", "xlink:href"],
        childList: true,
        subtree: true
      });
      if (hasCustomerPhoto) scheduleArtworkRender();
    }

    if (container && !artworkContainerObserver) {
      artworkContainerObserver = new MutationObserver(function () {
        if (sourceArtworkSvg() !== observedArtworkSvg) observeArtworkSource();
      });
      artworkContainerObserver.observe(container, { childList: true, subtree: true });
    }

    if (artwork && teeinblueBootstrapObserver) {
      teeinblueBootstrapObserver.disconnect();
      teeinblueBootstrapObserver = null;
    }
  }

  observeArtworkSource();
  if (!observedArtworkSvg) {
    teeinblueBootstrapObserver = new MutationObserver(observeArtworkSource);
    teeinblueBootstrapObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if ("ResizeObserver" in window) {
    mockupResizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var container = entry.target;
        var overlay = container.querySelector("[data-mfy-ai-mockup-overlay]");
        if (!overlay) return;
        applyMockupGeometry(container, overlay, overlay.getAttribute("data-mfy-ai-mockup-overlay"));
      });
    });
  }

  document.addEventListener("shopify:section:load", function () {
    if (hasCustomerPhoto && currentObjectUrl) {
      var root = comparison();
      if (root) {
        root.querySelectorAll("[data-mfy-original-photo-bg], [data-mfy-original-photo]").forEach(function (image) {
          image.src = currentObjectUrl;
        });
        root.classList.add("has-original-photo");
      }
    }
    observeArtworkSource();
    restorePersistedArtwork();
  });

  personalizationText = storedPersonalizationText();
  personalizationColor = selectedPersonalizationColor() || storedPersonalizationColor() || "#000000";
  syncColorCartProperty(personalizationColor);
  restorePersistedArtwork();
  renderPersonalizationLayer();
  scheduleNameSync();
  namePollTimer = window.setInterval(pollPersonalizationInput, 400);
  preloadMockupImages();

  window.addEventListener("pagehide", function () {
    window.cancelAnimationFrame(renderTimer);
    window.cancelAnimationFrame(nameSyncFrame);
    window.clearTimeout(retryTimer);
    window.clearInterval(namePollTimer);
    if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
    if (mockupResizeObserver) mockupResizeObserver.disconnect();
    if (artworkSourceObserver) artworkSourceObserver.disconnect();
    if (artworkContainerObserver) artworkContainerObserver.disconnect();
    if (teeinblueBootstrapObserver) teeinblueBootstrapObserver.disconnect();
  });
})();
